













import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import dayjs from 'dayjs';
// noinspection TypeScriptCheckImport
import duration from 'dayjs/plugin/duration';
import type {Duration} from 'dayjs/plugin/duration';

dayjs.extend(duration);


@Component
export default class CountdownTimer extends Vue {
	@Prop({required: true})
	targetSecond!: number;

	clockInterval: ReturnType<typeof setInterval> | null = null;
	countdownMilliseconds = 1; // initialize to >0 so we show countdown-active slot
	loading = true;

	private readonly FORMAT = 'HH:mm:ss';

	get counter(): string {
		if(this.duration.asDays() > 1) {
			return this.duration.format(`D days, ${this.FORMAT}`);
		}
		return this.duration.format(this.FORMAT);
	}

	get duration(): Duration {
		/*
		 * We don't just want to return 0, but also stop the interval
		 * computing the countdown (done in interval, itself).
		 */
		if(this.countdownMilliseconds <= 0) {
			return dayjs.duration(0);
		}

		return dayjs.duration(this.countdownMilliseconds);
	}

	@Watch('targetSecond') // non-immediate, allow to initialize
	updateTarget() {
		this.loading = true;

		const now = Date.now();
		const targetMS = this.targetSecond * 1000;

		this.countdownMilliseconds = Math.max(targetMS - now, 0);
		if(this.countdownMilliseconds > 0) {
			this.clockInterval = setInterval(() => {
				this.countdownMilliseconds = targetMS - Date.now();

				if(this.countdownMilliseconds <= 0) {
					this.cancelInterval();
				}
			}, 1000);
		}

		this.loading = false;
	}

	unmounted(): void {
		this.cancelInterval();
	}


	cancelInterval(): void {
		if(this.clockInterval) {
			clearInterval(this.clockInterval);
		}
	}
}
